export const StyleSheet = {
  groupContainer: {
    width: '100%',
  },
  groupHeader: (colourFg: string | null, colourBg: string | null) => ({
    padding: '4px 10px',
    fontWeight: 600,
    color: colourFg ?? undefined,
    backgroundColor: colourBg ?? undefined,
  }),
};
